import React, { useState, useEffect, Suspense } from 'react'

import ReactDOM from 'react-dom'
import update from 'immutability-helper'
import moment from 'moment'
import Hints from 'views/pages/UIElements/Hints'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Button, Input, ModalBody, Spinner } from 'reactstrap'
import * as questionBankActions from 'store/QuestionBank/actions'

import {
  faChevronLeft,
  faCog,
  faEdit,
  faList,
  faMinus,
  faPlus,
  faTrash,
  faTrashAlt,
  faFolder,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CustomModal from './CustomModal'
import Editor from './Editor'
import TextEditor from '../../../TextEditor'
import File from 'views/pages/File'
import Search from 'views/pages/Search'
import { setCount } from 'store/Course/actions'

import './style.css'
import { useSelector, useDispatch } from 'react-redux'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import EditDeleteButtonsContainer from 'components/Custom/EditDeleteButtonsContainer'
import Loader from 'views/pages/Loader'
import { undo } from 'store/Course/actions'
import { closeQuizModal } from 'store/Course/actions'
import GridQuestions from './GridQuestions'
import { deleteQuestion } from 'store/Course/actions'

/*eslint-disable*/

const portal = document.createElement('div')
document.body.appendChild(portal)

// Move sortable item
const moveItem = (dragIndex, hoverIndex, props) => {
  const { questions } = props.quiz
  const dragCard = questions[dragIndex]

  const reorderedQuizzes = update(questions, {
    $splice: [
      [dragIndex, 1],
      [hoverIndex, 0, dragCard],
    ],
  })

  props.reorderQuizzess(reorderedQuizzes)
}

const InputRadio = (props) => (
  <div className='custom-control custom-control-info custom-radio mt-3 '>
    <input
      className='custom-control-input '
      type='radio'
      name='option'
      value={props.item.value}
      id={`name-${props.index}`}
      checked={props.question.correct_answer === props.item.id}
      onChange={() => props.onChangeQuestion('correct_answer', props.item.id)}
    />
    <label className='custom-control-label' htmlFor={`name-${props.index}`}>
      {props.label}
    </label>
  </div>
)

const InputCheckbox = (props) => (
  <input
    type='checkbox'
    name='option'
    value={props.item.value}
    id={`name-${props.index}`}
    checked={props.item.correct_answer}
    onChange={() =>
      props.onChangeOption(
        props.index,
        'correct_answer',
        props.item.correct_answer ? null : props.item.id
      )
    }
  />
)

const Question = (props) => {
  const dispatch = useDispatch()
  const onChangeQuestion = (value) => {
    props.onChangeQuestion('name', value)
  }

  const { question } = props

  let language = props.language || {}

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-4'>
          <div className=' d-flex align-items-center'>
            <label className='mb-0 mr-1'>
              {language.courses ? language.courses.points : null}:{' '}
            </label>
            <Input
              style={{ width: '50px' }}
              type='number'
              bsSize='sm'
              min='0'
              value={question.points}
              onChange={(event) =>
                props.onChangeQuestion('points', event.target.value)
              }
              className='mr-1'
            />{' '}
            <div>
              /{' '}
              {props.quiz.questions
                .map((item) => parseInt(item.points))
                .reduce((total, value) => total + value) || 0}
            </div>
          </div>
        </div>
        {/* <div className='col-md-4'>
					<div className='question-buttons-wrapper'>
						{!question.newQuestion ? (
							<button
								className='btn btn-default'
								onClick={props.deleteQuestion.bind(
									null,
									props.quiz.activeIndex
								)}
							>
								{language.general ? language.general.delete : null}
							</button>
						) : null}
						<button className='btn btn-default' onClick={props.undo}>
							{language.general ? language.general.cancel : null}
						</button>
						<button
							className='btn btn-default btn-info'
							onClick={props.saveQuestion}
						>
							{language.general ? language.general.save : null}
						</button>
					</div>
				</div> */}
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='question-title-wrapper mt-2'>
            <TextEditor
              textContent={question.text || question.name}
              onChangeText={onChangeQuestion}
              changeProperty='name'
              placeholder={
                language.courses ? language.courses.question_name : null
              }
              setOptions={{
                buttonList: [
                  ['bold', 'underline', 'italic', 'formatBlock'],
                  ['table', 'image', 'link'],
                ],
              }}
            />
          </div>
        </div>
      </div>
      {question.options &&
        question.options.map((item, index) => (
          <div className='row' key={index}>
            <div className='col-12'>
              <div className='question-option-row d-flex'>
                {question.type === 3 ||
                question.type === 7 ||
                question.type === 8 ? (
                  // <InputCheckbox
                  // 	{...props}
                  // 	question={question}
                  // 	item={item}
                  // 	index={index}
                  // />
                  ''
                ) : question.type === 5 ||
                  question.type === 6 ? null : question.type !== 4 &&
                  question.type !== 1 &&
                  question.type !== 2 ? (
                  <InputRadio
                    {...props}
                    question={question}
                    item={item}
                    index={index}
                  />
                ) : null}

                {question.type === 1 ? (
                  <div className='question-option-wrapper question-type-1-wrapper'>
                    <InputRadio
                      {...props}
                      question={question}
                      item={item}
                      index={index}
                      label={
                        item.value === 1
                          ? language.courses
                            ? language.courses.true
                            : null
                          : language.courses
                          ? language.courses.false
                          : null
                      }
                    />

                    <Button
                      className='btn-icon px-3 py-2 mt-1'
                      color='info'
                      type='button'
                      outline
                      onClick={() =>
                        props.toggleCurrentQuestionDescription(index)
                      }
                    >
                      <span
                        className='btn-inner--icon '
                        style={{ fontSize: '17px' }}
                      >
                        <FontAwesomeIcon
                          icon={item.isDescriptionActive ? faMinus : faPlus}
                        />{' '}
                      </span>
                      <span className='btn-inner--text'>
                        {language.courses
                          ? language.courses.option_feedback
                          : null}
                      </span>
                    </Button>

                    <div
                      className='mt-2'
                      style={{
                        display: item.isDescriptionActive ? '' : 'none',
                      }}
                    >
                      <Editor
                        name='description'
                        onChange={(data) => {
                          props.onChangeOptionDescription(data, index)
                        }}
                        config={{
                          toolbar: ['bold', 'italic', '|', 'link'],
                        }}
                      />
                    </div>
                  </div>
                ) : question.type === 5 ||
                  question.type === 6 ||
                  question.type === 7 ||
                  question.type === 8 ? null : question.type === 2 ? (
                  <div className='question-option-wrapper d-flex my-3 w-75'>
                    <InputRadio
                      {...props}
                      question={question}
                      item={item}
                      index={index}
                    />
                    <div className='col p-0'>
                      <div className='d-flex align-items-center'>
                        <Input
                          type='text'
                          value={item.name}
                          onChange={(e) =>
                            props.onChangeOption(index, 'name', e.target.value)
                          }
                        />
                        {question.options.length > 2 ? (
                          <Button
                            className='ml-2 '
                            size='sm'
                            color='danger'
                            outline
                            onClick={() => props.deleteOption(index)}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        ) : null}
                      </div>

                      <Button
                        className='btn-icon px-3 py-2 mt-1'
                        color='info'
                        type='button'
                        outline
                        onClick={() =>
                          props.toggleCurrentQuestionDescription(index)
                        }
                      >
                        <span
                          className='btn-inner--icon '
                          style={{ fontSize: '17px' }}
                        >
                          <FontAwesomeIcon
                            icon={item.isDescriptionActive ? faMinus : faPlus}
                          />{' '}
                        </span>
                        <span className='btn-inner--text'>
                          {language.courses
                            ? language.courses.option_feedback
                            : null}
                        </span>
                      </Button>

                      <div
                        className='mt-2'
                        style={{
                          display: item.isDescriptionActive ? '' : 'none',
                        }}
                      >
                        <Editor
                          name='description'
                          onChange={(data) => {
                            props.onChangeOptionDescription(data, index)
                          }}
                          config={{
                            toolbar: ['bold', 'italic', '|', 'link'],
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='mt-3 d-flex align-items-center w-75'>
                    {question.type === 3 && (
                      <input
                        className='mr-1'
                        type='checkbox'
                        name='option'
                        value={item.value}
                        id={`name-${index}`}
                        checked={item.correct_answer}
                        onChange={() =>
                          props.onChangeOption(
                            index,
                            'correct_answer',
                            item.correct_answer ? null : item.id
                          )
                        }
                      />
                    )}

                    <Input
                      type='text'
                      bsSize='sm'
                      value={item.name}
                      onChange={(e) =>
                        props.onChangeOption(index, 'name', e.target.value)
                      }
                    />

                    {question.options.length > 2 ? (
                      <Button
                        className='ml-2'
                        size='sm'
                        color='danger'
                        outline
                        onClick={() => props.deleteOption(index)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      <div className='row'>
        {question.type === 5
          ? question.options.map((item, index) =>
              item.type === 3 ? null : (
                <div key={index} className='col-5 mt-3'>
                  <div className='d-flex align-items-center'>
                    <Input
                      type='text'
                      value={item.name || ''}
                      onChange={(e) =>
                        props.onChangeOption(index, 'name', e.target.value)
                      }
                    />
                    {question.options.length > 2 && item.type === 2 ? (
                      <Button
                        className='ml-2 '
                        size='sm'
                        color='danger'
                        outline
                        onClick={() => props.deleteMatchOption(item.id)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    ) : null}
                  </div>
                </div>
              )
            )
          : null}
      </div>

      {question.type === 8 && (
        <div>
          <GridQuestions />
        </div>
      )}

      <div className='row'>
        {question.type === 6
          ? question.options.map((item, index) => (
              <div key={index} className='col-12'>
                <div className='question-option-row'>
                  <InputRadio
                    {...props}
                    question={question}
                    item={item}
                    index={index}
                  />
                  {item.name ? <span>{item.name}</span> : null}
                  <File
                    onChange={() => props.setOptionImage(index)}
                    placeholder={
                      language.general ? language.general.choose_file : null
                    }
                  />
                  {question.options.length > 2 ? (
                    <button
                      className='btn btn-info'
                      onClick={() => props.deleteMatchOption(item.id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  ) : null}
                </div>
              </div>
            ))
          : null}
      </div>

      <div className='row mt-4'>
        <div className='col-12'>
          <div className='add-option-btn-wrapper'>
            {question.type !== 1 &&
            question.type !== 7 &&
            question.type !== 8 ? (
              <Button outline color='info' onClick={props.addOption}>
                {language.courses ? language.courses.add_response : null}
              </Button>
            ) : null}
          </div>
        </div>
      </div>

      {question.type === 5 ? (
        <h3 className='mt-3'>
          {language.courses ? language.courses.distractions : null}
        </h3>
      ) : null}
      <div className='row mt-2'>
        {question.type === 5
          ? question.options.map((item, index) =>
              item.type === 3 ? (
                <div className='col-5 mt-3' key={index}>
                  <div className='d-flex align-items-center'>
                    <Input
                      type='text'
                      value={item.name || ''}
                      onChange={(e) =>
                        props.onChangeOption(index, 'name', e.target.value)
                      }
                    />
                    {question.options.length > 2 ? (
                      <Button
                        className='ml-2 '
                        size='sm'
                        color='danger'
                        outline
                        onClick={() => props.deleteOption(index)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    ) : null}
                  </div>
                </div>
              ) : null
            )
          : null}
        {question.type === 5 ? (
          <div className='col-12 mt-3'>
            <div className='add-option-btn-wrapper'>
              <Button
                outline
                color='info'
                className='btn'
                onClick={props.addDistraction}
              >
                {language.courses ? language.courses.add_distraction : null}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
      <div className='col-md-4 px-0 my-4  d-inline-block '>
        <div>
          {/* <Button
            className='btn mr-1 px-5 py-2'
            color='info'
            onClick={props.saveQuestion}
          >
            {language.general ? language.general.save : null}
          </Button> */}
          <SubmitModalButton
            text={language.general ? language.general.save : null}
            customFn={props.saveQuestion}
          />
          {/* <Button
            className='btn text-info px-4 py-2'
            color='transparent'
            outline
            onClick={props.undo}
          >
            {language.general ? language.general.cancel : null}
          </Button> */}
          {!question.newQuestion ? (
            // <Button
            //   className='btn px-4 py-2'
            //   color='danger'
            //   outline
            //   onClick={props.deleteQuestion.bind(null, props.quiz.activeIndex)}
            // >
            //   {language.general ? language.general.delete : null}
            // </Button>
            <DeleteButton
              text={language.general ? language.general.delete : null}
              customFn={() => {
                props.undo()
                dispatch(deleteQuestion(props.quiz.activeIndex))
              }}
            />
          ) : null}
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
            customFn={props.undo}
          />
        </div>
      </div>
    </div>
  )
}

const QuizSettings = (props) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  const today = moment().format('YYYY-MM-DD')

  // let date = props.quiz.quizStartDate && new Date(props.quiz.quizStartDate)
  // const stringDate = date && date.toLocaleDateString()
  // const replacedDate = stringDate && stringDate.replaceAll('/', '-')
  // const quizStartDate =
  // 	replacedDate && moment(replacedDate).format('YYYY-MM-DD')

  return (
    <div className=''>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>
            {language.courses ? language.courses.allow_quiz_retake : null}
          </span>
          <Hints message={'Allows managers to set option to retake the quiz'} />
        </div>
        <div className='question-toggle-container'>
          {props.quiz.retake ? (
            <div className='d-flex align-items-center justify-content-start'>
              <Input
                style={{ width: '30%' }}
                bsSize='sm'
                type='text'
                name='group_length'
                onChange={(event) =>
                  props.setRetakeQuizCount(event.target.value)
                }
                value={props.quizAttemptsAllowed || ''}
              ></Input>
              <label className='ml-1'>
                {language.courses ? language.courses.times : null}
              </label>
            </div>
          ) : null}
          <div className='mr-3'>
            <label className='custom-toggle'>
              <input
                id='selfAssignable'
                type='checkbox'
                name='selfAssignable'
                checked={props.quiz.retake || false}
                onChange={props.toggleQuizRetake}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>
            {language.courses ? language.courses.quiz_pass_percentage : null}
          </span>
          <Hints
            message={'Allows managers to set quiz pass percentage value'}
          />
        </div>
        <div className='question-toggle-container'>
          {props.quiz.isPassPercentageActive ? (
            <div className='d-flex align-items-center justify-content-start'>
              <Input
                style={{ width: '30%' }}
                className=''
                bsSize='sm'
                type='text'
                name='group_length'
                onChange={(event) =>
                  props.setPassPercentage(event.target.value)
                }
                value={props.quiz.quizPassPercentage || ''}
              />
              <label className='ml-1 '>%</label>
            </div>
          ) : null}
          <div className='mr-3'>
            <label className='custom-toggle'>
              <input
                type='checkbox'
                checked={props.quiz.isPassPercentageActive || false}
                onChange={props.togglePassPercentage}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>Set quiz timer</span>
          <Hints message={'Allows managers to set quiz timer'} />
        </div>
        <div className='question-toggle-container'>
          {props.quiz.isQuizTimerActive ? (
            <div className='d-flex align-items-center justify-content-start'>
              <Input
                style={{ width: '30%' }}
                bsSize='sm'
                type='text'
                name='group_length'
                onChange={(event) => dispatch(setCount(event.target.value))}
                value={props.quiz.quizTimer || ''}
              />
              <label className='ml-1'>minutes</label>
            </div>
          ) : null}
          <div className='mr-3'>
            <label className='custom-toggle '>
              <input
                type='checkbox'
                checked={props.quiz.isQuizTimerActive || false}
                onChange={props.toggleQuizTimer}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>
            {language.courses ? language.courses.randomize_options_order : null}
          </span>
          <Hints
            message={'Allows managers to set randomize order of the questions'}
          />
        </div>
        <div className='mr-3'>
          <label className='custom-toggle'>
            <input
              type='checkbox'
              checked={props.quiz.randomizeOrder}
              onChange={props.toggleRandomizeOrder}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
    </div>
  )
}

const QuizOverlayHeader = (props) => {
  let language = props.language || {}

  const questionOptions = [
    {
      name: language.courses ? language.courses.add_new_question : null,
      value: '0',
    },
    { name: language.courses ? language.courses.true_false : null, value: '1' },
    {
      name: language.courses ? language.courses.multiple_choice : null,
      value: '2',
    },
    {
      name: 'Short Paragraph',
      value: '7',
    },
    {
      name: 'Grid Questions',
      value: '8',
    },
    { name: language.courses ? language.courses.checkbox : null, value: '3' },
    {
      name: language.courses ? language.courses.correct_order : null,
      value: '4',
    },
    { name: language.courses ? language.courses.matching : null, value: '5' },
    { name: language.courses ? language.courses.image : null, value: '5' },
  ]

  return (
    <div className='mt-2'>
      <div className='header-container'>
        <Input
          className='add-question  border-info text-info font-weight-bolder'
          style={{ width: 'unset', height: 'unset' }}
          name='language'
          type='select'
          onChange={props.selectQuestion}
          onClick={() => props.handleAddNewQuestion()}
        >
          {questionOptions.map((item, index) => (
            <option
              key={index}
              value={item.value}
              className='text-dark bg-white'
            >
              {item.name}
            </option>
          ))}
        </Input>
        <button
          onClick={() =>
            props.handleClickQuizSettings(!props.isQuizSettingsOpened)
          }
          className='ml-2 btn btn-outline-info'
        >
          <FontAwesomeIcon
            icon={props.isQuizSettingsOpened ? faChevronLeft : faCog}
            className='mr-2'
          />
          {props.isQuizSettingsOpened
            ? 'Back to questions list'
            : 'Quiz settings'}
        </button>
        <button
          onClick={() => props.handleClickQuestionBank()}
          className='btn  btn-outline-info '
        >
          <FontAwesomeIcon icon={faList} className='mr-2' />

          {props.isQuestionBankOpened
            ? 'Back to questions list'
            : 'Select from question bank'}
        </button>
      </div>
      <span className='align-self-end h4'>
        {props.quiz.questions.length}{' '}
        {language.courses ? language.courses.questions : null}{' '}
      </span>
    </div>
  )
}

function QuizOverlay(props) {
  const [isQuizSettingsOpened, setIsQuizSettingsOpened] = useState(false)
  const [isQuestionBankOpened, setIsQuestionBankOpened] = useState(false)

  const handleClickQuizSettings = () => {
    setIsQuizSettingsOpened(!isQuizSettingsOpened)
    setIsQuestionBankOpened(false)
  }

  const handleClickQuestionBank = () => {
    setIsQuestionBankOpened(!isQuestionBankOpened)
    setIsQuizSettingsOpened(false)
  }

  const handleAddNewQuestion = () => {
    setIsQuizSettingsOpened(false)
    setIsQuestionBankOpened(false)
  }

  return (
    <div className='row justify-content-between question-items-header'>
      <div className='col-md-12'>
        <QuizOverlayHeader
          isQuizSettingsOpened={isQuizSettingsOpened}
          isQuestionBankOpened={isQuestionBankOpened}
          handleClickQuizSettings={handleClickQuizSettings}
          handleClickQuestionBank={handleClickQuestionBank}
          handleAddNewQuestion={handleAddNewQuestion}
          {...props}
        />
      </div>
      <div className='col-md-12  mt-3'>
        {isQuizSettingsOpened ? (
          <QuizSettings
            handleClickQuizSettings={handleClickQuizSettings}
            {...props}
          />
        ) : isQuestionBankOpened ? (
          <QuestionBankList
            {...props}
            handleClickQuestionBank={handleClickQuestionBank}
          />
        ) : (
          <List {...props} />
        )}
      </div>
    </div>
  )
}
const FolderItem = (props) => {
  return (
    <div
      onClick={() => props.setOpenedFolder(props.folder)}
      key={props.folder.id}
      className='all-folder-containers'
    >
      <div className='book-item-question-bank rounded'>
        <a
          href={props.folder.path}
          target='_blank'
          className='folder-item-container'
        >
          {/* <FontAwesomeIcon
						style={{ color: '#c9c9c9', fontSize: '30px', marginRight: '5px' }}
						icon='folder'
						className='icon fas'
					/> */}
          <h5 title={props.folder.name}>{props.folder.name}</h5>
        </a>
      </div>
    </div>
  )
}

const QuestionBankList = (props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(questionBankActions.fetchAllFoldersFromQuestionBank())
  }, [])
  const language = props.language || {}
  const questionBank = useSelector((state) => state.questionBank)
  const { questions: quizQuestions = [] } = props.quiz
  const [questionData, setQuestionData] = useState(null)
  const [type, setType] = useState('')

  const [questionArray, setQuestionArray] = useState([])
  const [searchQuestion, setSearchQuestion] = useState('')
  // const questionBank = useSelector((state) => state.questionBank)

  const handleAddQuestion = (question) => {
    if (!questionArray.includes(question)) {
      setQuestionArray([...questionArray, question])
    } else {
      setQuestionArray(questionArray.filter((ques) => ques.id !== question.id))
    }
  }

  const filteredQuestions = questionBank.questions.filter((item) =>
    item.name.includes(searchQuestion.toLowerCase())
  )

  const isQuizQuestionsIncluded =
    questionBank.questions.length > 0 && quizQuestions.length > 0
      ? questionBank.questions.every((question) =>
          quizQuestions.some((quest) => quest.id === question.id)
        )
      : false

  const handleSaveQuestions = () => {
    props.saveQuestionFromBank(questionArray)
    setQuestionArray([])
  }

  const handleCancel = () => {
    props.handleClickQuestionBank()
  }

  return (
    <div className='questions-container '>
      <div className='my-3'>
        {!isQuizQuestionsIncluded && questionBank.questions.length > 0 && (
          <div className='d-flex justify-content-between'>
            <div>
              <button
                className='btn btn-sm bg-transparent mr-1'
                onClick={handleCancel}
              >
                {language.general ? language.general.cancel : null}
              </button>
              <button
                className='btn  btn-info py-1 px-3'
                onClick={handleSaveQuestions}
              >
                Add questions
              </button>
            </div>
            <Search
              placeholder={
                language.general ? language.general.courses_completed : null
              }
              value={searchQuestion}
              onChange={(event) => setSearchQuestion(event.target.value)}
            />
          </div>
        )}
      </div>

      {questionBank.openedFolder ? (
        <div
          style={{
            display: 'flex',
            position: 'relative',
            marginBottom: '20px',
          }}
        >
          <span
            onClick={() => dispatch(questionBankActions.setCloseFolder())}
            className='back-to-question-bank'
          >
            Question Bank{' '}
          </span>{' '}
          {` > `}
          <span className='selected-folder'>
            {questionBank.openedFolder.name}
          </span>
        </div>
      ) : (
        <div style={{ marginBottom: '40px' }}>
          <div className='folders-count'>{`Folders (${
            questionBank &&
            questionBank.allFolders &&
            questionBank.allFolders.length
          })`}</div>
          <div className='question-bank-folder-container'>
            {questionBank &&
            questionBank.allFolders &&
            questionBank.allFolders.length
              ? questionBank.allFolders.map((folder) => {
                  return (
                    <FolderItem
                      {...props}
                      folder={folder}
                      setOpenedFolder={(folder) =>
                        dispatch(questionBankActions.setOpenedFolder(folder))
                      }
                    />
                  )
                })
              : ''}
          </div>
        </div>
      )}
      <Suspense
        fallback={
          <div className='text-center'>
            {/* <Spinner /> */}
            <Loader />
          </div>
        }
      >
        {/* <div className='col-12'>
					<QuestionList
						setQuestionData={setQuestionData}
						searchQuestion={searchQuestion}
						setType={setType}
						setOpenMoveQuestion={(id) =>
							dispatch(questionBankActions.setOpenMoveQuestion(id))
						}
						moveQuestionOnChange={(event) =>
							dispatch(questionBankActions.moveQuestionOnChange(event))
						}
						language={language}
						{...questionBank}
					/>
				</div> */}
      </Suspense>
      {filteredQuestions.map((item, index) =>
        quizQuestions.some((question) => question.id === item.id) ? null : (
          <QuestionContainer
            manageAddingQuestion={handleAddQuestion}
            item={item}
            index={index}
            key={index}
          />
        )
      )}
      {isQuizQuestionsIncluded
        ? 'You have selected all questions from Question Bank'
        : questionBank.questions.length === 0 &&
          'There are no questions available in question bank'}
    </div>
  )
}

const QuestionContainer = ({ item, index, manageAddingQuestion }) => {
  const [active, setActive] = useState(false)

  const handleClick = () => {
    setActive(!active)
    manageAddingQuestion(item)
  }

  const shortenText = () => {
    let text = item.name
    if (
      typeof text === 'string' &&
      text.includes('src=') &&
      text.includes('<p>')
    ) {
      text = text.split('</p>')[0].slice(0, 100) + '</p>'
    } else if (text.includes('se-image-container')) {
      text =
        text.split('se-image-container')[0] +
        'image-size' +
        text.split('se-image-container')[1]
    } else {
      text = text.split('</p>')[0].slice(0, 100) + '</p>' || item.text
    }
    return text
  }

  return (
    <div
      className={`question-container border rounded mb-2 p-3 ${
        active ? 'active' : ''
      }`}
      onClick={handleClick}
    >
      <div className='question-number'>{index + 1}</div>
      <div
        dangerouslySetInnerHTML={{ __html: shortenText() }}
        className='col-11  dangerous-html'
      />
    </div>
  )
}

function PortalAwareItem({ provided, snapshot, item, index, props }) {
  const usePortal = snapshot.isDragging

  const child = (
    <div
      className={`col-12 mb-2 p-2 border rounded draggable-item  draggable-bg   ${
        snapshot.isDragging ? 'active' : ''
      }`}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
    >
      <strong>{index + 1}</strong>
      <div
        key={index}
        dangerouslySetInnerHTML={{
          __html: (typeof item.name === 'string' && item.name) || item.text,
        }}
        className='col-11 question-item-title-select  text-darker dangerous-html py-1'
      />
      <EditDeleteButtonsContainer>
        <Button
          onClick={props.editQuestion.bind(null, index)}
          outline
          color='light'
          className='shadow-none'
          size='sm'
        >
          <FontAwesomeIcon icon={faEdit} />
        </Button>

        <Button
          onClick={props.deleteQuestion.bind(null, index)}
          outline
          color='danger'
          className='shadow-none'
          size='sm'
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </Button>
      </EditDeleteButtonsContainer>
    </div>
  )

  if (!usePortal) {
    return child
  }

  // if dragging - put the item in a portal
  return ReactDOM.createPortal(child, portal)
}

const List = (props) => {
  const handleOnDragEnd = (result) => {
    if (!result.destination) return
    moveItem(result.source.index, result.destination.index, props)
  }
  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable key='questions' droppableId='questions'>
        {(droppableProvided) => (
          <div
            {...droppableProvided.droppableProps}
            ref={droppableProvided.innerRef}
          >
            {props.quiz.questions.map((item, index) => {
              return (
                <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={index}
                >
                  {(draggableProvided, draggableSnapshot) => (
                    <PortalAwareItem
                      item={item}
                      provided={draggableProvided}
                      snapshot={draggableSnapshot}
                      index={index}
                      props={props}
                    />
                  )}
                </Draggable>
              )
            })}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

const ManageQuestions = (props) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(closeQuizModal())
  }, [])

  return (
    <CustomModal
      courseId={props.course_id}
      title={language.courses ? language.courses.manage_questions : null}
      size='xl'
      className='question-modal'
      isQuizModal={true}
    >
      <ModalBody style={{ height: '100%' }}>
        {(() => {
          switch (props.quiz.activeIndex) {
            case -1:
              return <QuizOverlay {...props} />
            default:
              return (
                <Question
                  {...props}
                  question={props.quiz.questions[props.quiz.activeIndex]}
                />
              )
          }
        })()}
      </ModalBody>
    </CustomModal>
  )
}

// const QuestionList = (props) => {
// 	const { questions } = props

// 	console.log(props, 'propsQuestionList')

// 	const { setQuestionData, setType } = props

// 	const dispatch = useDispatch()

// 	return (
// 		<div className='col-12 px-0'>
// 			{console.log(questions, 'questions')}
// 			{/* {questions && questions.length
// 				? questions
// 						.filter((item) =>
// 							item.name
// 								.toLowerCase()
// 								.includes(props.searchQuestion.toLowerCase())
// 						)
// 						.map((item, index) => (
// 							<div
// 								key={index}
// 								className='row align-items-center justify-content-between mb-2 border border-bottom p-2 px-3 rounded'
// 							>
// 								<div
// 									dangerouslySetInnerHTML={{
// 										__html:
// 											(typeof item.name === 'string' && item.name) || item.text,
// 									}}
// 									className=' question-item-title '
// 									style={{ flexDirection: 'column' }}
// 								/>
// 								<div className='d-flex align-items-center'></div>
// 							</div>
// 						))
// 				: ''} */}
// 		</div>
// 	)
// }

export default ManageQuestions
